import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_dropdown",
  "use": "svg_dropdown-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\" id=\"svg_dropdown\"><path d=\"m1 1 4 4 4-4\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol